const makeString = (value: number | null): string => {
  if (value === null || value === undefined || Number.isNaN(value)) {
    return '';
  }
  return `${value}`;
};

export default makeString;
